// !!DEPRECATED!! now done dynamically in GameDefinition.js by using Board.js
export const GameDefinitionData = [
    {
        name: 'Milestone',
        icon: 200,
        Additional: 1,
        Cost: 2000,
        blueAmount: 4,
        greenAmount: 0,
        redAmount: 4,
    },
    {
        name: 'Milestone',
        icon: 200,
        Additional: 2,
        Cost: 1000,
        blueAmount: 4,
        greenAmount: 1,
        redAmount: 4,
    },
    {
        name: 'Milestone',
        icon: 200,
        Additional: 3,
        Cost: 2000,
        blueAmount: 3,
        greenAmount: 1,
        redAmount: 3,
    },
    {
        name: 'Milestone',
        icon: 200,
        Additional: 4,
        Cost: 1000,
        blueAmount: 2,
        greenAmount: 0,
        redAmount: 2,
    },
    {
        name: 'Milestone',
        icon: 200,
        Additional: 5,
        Cost: 500,
        blueAmount: 0,
        greenAmount: 0,
        redAmount: 0,
    },
    {
        name: 'Milestone',
        icon: 200,
        Additional: 6,
        Cost: 500,
        blueAmount: 0,
        greenAmount: 0,
        redAmount: 0,
    },
    {
        name: 'Milestone',
        icon: 200,
        Additional: 7,
        Cost: 500,
        blueAmount: 0,
        greenAmount: 0,
        redAmount: 0,
    },
    {
        name: 'Milestone',
        icon: 200,
        Additional: 8,
        Cost: 500,
        blueAmount: 0,
        greenAmount: 0,
        redAmount: 0,
    },
    {
        name: 'Gate',
        icon: 200,
        Additional: 1,
        Cost: 2000,
        blueAmount: 2,
        greenAmount: 0,
        redAmount: 2,
    },
    {
        name: 'Gate',
        icon: 200,
        Additional: 2,
        Cost: 3000,
        blueAmount: 4,
        greenAmount: 2,
        redAmount: 4,
    },
    {
        name: 'Gate',
        icon: 200,
        Additional: 3,
        Cost: 3000,
        blueAmount: 3,
        greenAmount: 1,
        redAmount: 4,
    },
];

export const SecondGateData = [
    {
        gate: '1',
        Cost: 2000,
        blueAmount: 2,
        greenAmount: 0,
        redAmount: 2,
    },
    {
        gate: '2',
        Cost: 3000,
        blueAmount: 4,
        greenAmount: 2,
        redAmount: 4,
    },
    {
        gate: '3',
        Cost: 3000,
        blueAmount: 3,
        greenAmount: 1,
        redAmount: 4,
    },
];
